<template>
	<div class="suspect">
		<div class="suspect-container">
      <!--游戏规则-->
      <transition name="hide">
        <div class="rules" v-on:touchstart="hideRules" v-show="isShow">
          <div class="rules-bg">
            <div class="rules-light"></div>
          </div>
        </div>
      </transition>

			<!--人物列表-->
			<div class="character-box">
				<div class="character-notice">{{characterMsg}}</div>
				<div class="swiper-container character-container">
					<div class="swiper-wrapper character-wrapper">
						<div class="swiper-slide character-slide" 
							 v-for="character in characters"
							 :key="character.name">
							 <div class="character-bg">
                 <div class="character-image">
                    <img v-bind:src="character.linkOrigin" 
                        v-bind:alt="character.name"/>
                  </div>
                  <p class="character-name">{{character.name}}</p> 
               </div>	 	 
						</div>
					</div>
				</div>

        <!--人物滑动手势-->
        <div class="character-gesture"></div>
			</div>

			<!--物品-->
			<div class="goods-container">
				<div class="goods-wrapper">
					<div class="goods-box">
						<!--发光-->
						<div class="goods-light">
							<div class="goods-light-rotate"></div>
						</div>

						<!--物品图像-->
						<div class="goods-image"
									   v-on:touchstart="moveStart($event)"
										 v-on:touchmove.prevent="move($event)"
										 v-on:touchend="moveEnd($event)">
							<img v-bind:src="goods[goodsNum].link" 
                   v-bind:alt="goods[goodsNum].name"/>
						</div>

						<!--物品滑动手势-->
						<div class="goods-gesture"></div>
					</div>
					<div class="goods-notice">{{goodsMsg}}</div>	
				</div>	
			</div>

      <!--音效-->
      <div class="audio-container">
        <audio id="sound">
          <source src="./ding.mp3" type="audio/mpeg">
          <source src="./ding.aac" type="audio/aac">
        </audio>
      </div>
		</div>
	</div>
</template>

<script>
import store from "@/store/store.js";
let Swiper = require("@/plugins/swiper.min.js").Swiper;
export default {
  data() {
    return {
      isShow: true,
      characters: [
        {
          name: "严谨女教师",
          goods: "tea",
          lipstick: "好不容易有人送我的!",
          tea: "最近身材有点走样了!",
          beer: "天气太热，想喝点凉的~",
          towel: "下班后运动走起的必需品",
          linkOrigin: require("./images/characters/teacher.png"),
          linkActive: require("./images/characters/teacher_active.png")
        },
        {
          name: "健美男教练",
          goods: "",
          lipstick: "送老婆的周年礼品!",
          tea: "先减脂，再操肌!",
          beer: "啤酒练肌大法，我能行!",
          towel: "必须是我的，职业需求",
          linkOrigin: require("./images/characters/coach.png"),
          linkActive: require("./images/characters/coach_active.png")
        },
        {
          name: "广场舞大妈",
          goods: "towel",
          lipstick: "女儿说让我带去跳广场舞!",
          tea: "大妈也可以很爱美!",
          beer: "老公非要我上网买!",
          towel: "这可是广场舞标配哦!",
          linkOrigin: require("./images/characters/aunt.png"),
          linkActive: require("./images/characters/aunt_active.png")
        },
        {
          name: "嘻哈boy",
          goods: "beer",
          lipstick: "男生也可以化妆啊!",
          tea: "佛性减肥，从我做起",
          beer: "听说Rap和啤酒是好朋友!",
          towel: "有时候跳个街舞会出超多汗!",
          linkOrigin: require("./images/characters/boy.png"),
          linkActive: require("./images/characters/boy_active.png")
        },
        {
          name: "性感大美女",
          goods: "lipstick",
          lipstick: "最新型号，必须是我的!",
          tea: "我可不能变胖!",
          beer: "明晚开Party就喝光它!",
          towel: "老公需要它!",
          linkOrigin: require("./images/characters/beauty.png"),
          linkActive: require("./images/characters/beauty_active.png")
        },
        {
          name: "中年油腻大叔",
          goods: "",
          lipstick: "最近要泡一个小妹妹!",
          tea: "人到中年，不得不注重健康了!",
          beer: "有空来两杯",
          towel: "呵呵，抹油的!",
          linkOrigin: require("./images/characters/uncle.png"),
          linkActive: require("./images/characters/uncle_active.png")
        }
      ],
      goods: [
        {
          name: "减肥茶",
          key: "tea",
          link: require("./images/goods/tea.png")
        },
        {
          name: "口红",
          key: "lipstick",
          link: require("./images/goods/lipstick.png")
        },
        {
          name: "啤酒",
          key: "beer",
          link: require("./images/goods/beer.png")
        },
        {
          name: "运动毛巾",
          key: "towel",
          link: require("./images/goods/towel.png")
        }
      ],
      characterNum: 0,         /* 当前人物列表中激活人物的编号 */
      goodsNum: 0,         /* 当前状态栏中激活物品的编号 */
      start: {             /* 物品移动起始点坐标 */
        startX: 0,
        startY: 0,
        startTime: 0,
      },
      previous: {          /* 拖动过程中上一个点的坐标 */
        previousX: 0,
        previousY: 0,
      },
      isCharacterActive: false,
      backgroundImageUrl: require("./images/characters/character_bg_used.png"),
      audioSrc: require("./ding.mp3"),
    };
  },
  computed: {
    characterMsg () {
      let goodsKey = this.goods[this.goodsNum].key;
      return this.characters[this.characterNum][goodsKey];
    },
    goodsMsg () {
      return this.goods[this.goodsNum].name;
    }
  },
	methods: {
    hideRules () {
      /* 隐藏游戏规则 */
      this.isShow = false;
      this.addGestures();
    },
    addGestures () {
      /* 添加人物滑动手势 */
      let characterGesture = document.querySelector(".character-gesture"),
              goodsGesture = document.querySelector(".goods-gesture");
      characterGesture.classList.add("character-gesture-active");
      characterGesture.addEventListener("webkitAnimationEnd", function () {
        this.style.display = "none";
        goodsGesture.classList.add("goods-gesture-active");
      });

      // 动画结束，移除物品滑动手势
      goodsGesture.addEventListener("webkitAnimationEnd", function () {
        this.style.display = "none";
      });
    },
		getOffset (elem) {
      /*
        返回DOM节点的位置
        @elem: {DOM},
      */ 
      return {
        left: elem.getBoundingClientRect().left,
        top: elem.getBoundingClientRect().top,
      }
		},
		moveStart (event) {
      /* @event: {event object}, 事件对象 */
      this.start.startX = this.previous.previousX = event.touches[0].clientX;
      this.start.startY = this.previous.previousY = event.touches[0].clientY;
      this.start.startTime = new Date();
		},
		move (event) {
      /* @event: {event object}, 事件对象 */
			let target = document.querySelector(".goods-image"),
			      left = window.getComputedStyle(target)["left"],
			       top = window.getComputedStyle(target)["top"];
      target.style.left = parseFloat(left) + event.changedTouches[0].clientX - this.previous.previousX + "px";
      target.style.top = parseFloat(top) + event.changedTouches[0].clientY - this.previous.previousY  + "px";
      this.previous.previousX = event.changedTouches[0].clientX;
      this.previous.previousY = event.changedTouches[0].clientY;

      this.switchSuspect(target, 
                         document.querySelector(".swiper-slide-active"));
		},
		moveEnd(event) {
      /*
        移动结束
        @event: {event object}, 事件对象
        1.不处在目标区域，回到起点
        2.处在目标区域
          1) 答对题，commit数据
          2）添加物品消失动画,并将人物激活状态设置为this.isCharacterActive = false;
          3) 添加已选中的背景图片,人物名称变灰 
          4）把人物重新设置为未激活状态
          5）切换物品栏物品
      */
      let target = document.querySelector(".goods-image"),
          characterActived = document.querySelector(".swiper-slide-active .character-image img");
      if(this.isCharacterActive) {
        if(this.goods[this.goodsNum].key === 
           this.characters[this.characterNum].goods) {
          // 1)答对题,提交数据
          this.$store.commit("increment");
         
        }

        // 2)添加物品消失动画,人物激活状态重置
        target.classList.add("goods-image-fade");
        this.isCharacterActive = false;

        // 3)添加已选中的背景图片
        let characterBg = document.querySelector(".swiper-slide-active .character-bg"),
            characterName = document.querySelector(".swiper-slide-active .character-name"),
            sound = document.querySelector("#sound");
            sound.src = this.audioSrc;
        characterBg.style.backgroundImage = `url(${this.backgroundImageUrl})`;
        characterName.style.cssText = "background-color: #404040; color: white;";
        sound.play();

        // 4)把人物重新设置为未激活状态
        window.setTimeout( () => {
          characterActived.src = this.characters[this.characterNum].linkOrigin;
          target.style.left = 0;
          target.style.top = 0;
          if(this.goodsNum < this.goods.length-1) {
            this.goodsNum++;
            target.classList.remove("goods-image-fade");
          } else {
            this.$router.push("/info");
          }
        }, 500);
      } else {
        /* 物品返回远处 */
        target.style.transition = "all 300ms";
        target.style.left = 0;
        target.style.top = 0;
        window.setTimeout(() => {
          target.style.transition = "none";
        }, 300);
      }
		},
    switchSuspect(movingTarget, dropTarget) {  
      /* 
        切换人物为激活状态
        @movingTarget: {Node}    拖动对象
        @dropTarget: {Node}      放置对象
      */
      let movingInfo = {
          x: this.getOffset(movingTarget).left,
          y: this.getOffset(movingTarget).top,
          width: parseFloat(window.getComputedStyle(movingTarget).width),
          height: parseFloat(window.getComputedStyle(movingTarget).height),
      }, dropInfo = {
          x: this.getOffset(dropTarget).left,
          y: this.getOffset(dropTarget).top,
          width: parseFloat(window.getComputedStyle(dropTarget).width),
          height: parseFloat(window.getComputedStyle(dropTarget).height),
      }, image = dropTarget.querySelector(".character-image img");
      this.characterNum = Array.prototype.slice.
                 call(dropTarget.parentElement.children).
                 indexOf(dropTarget);

      /* 矩形重合边界条件判断 */
      if(movingInfo.x + movingInfo.width > dropInfo.x &&
         movingInfo.x < dropInfo.x + dropInfo.width && 
         movingInfo.y + movingInfo.height > dropInfo.y &&
         movingInfo.y < dropInfo.y + dropInfo.height){
        image.src = this.characters[this.characterNum].linkActive;
        this.isCharacterActive = true;
      } else {
        image.src = this.characters[this.characterNum].linkOrigin;
        this.isCharacterActive = false;
      }

    }

  },
  store,
  mounted() {
    // 进入人物选择页面需要重新reset vuex和localStorage
    this.$store.commit("reset");
    let that = this,
    swiper = new Swiper(".swiper-container", {
      effect: "coverflow",
      slidesPerView: 2,
      centeredSlides: true,
      spaceBetween: 0,
      coverflowEffect: {
        rotate: 0,
        stretch: -10,
        depth: 150,
        modifier: 1.8,
        slideShadows: false,
      },
      on: {
        transitionEnd: function () {
          that.characterNum = this.activeIndex;
        }
      }
    });
  }
};
</script>

<style lang="scss">
@import "./suspect.scss";
</style>



// WEBPACK FOOTER //
// src/pages/suspect/suspect.vue